<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='project'
            :project='project'
            @update='update'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <construction-details
            v-if='project'
            :project='project'
            @update='update'
          ></construction-details>
        </v-col>
        <v-col cols='12' md='4'>
          <wc-data-box title='constructiony stuff'>
            <template v-slot:appendTitle>
              <span class='ml-3 caption font-italic grey--text'>(coming soon)</span>
            </template>
          </wc-data-box>
        </v-col>
        <v-col cols='12' md='4'>
          <contacts
            v-if='project'
            :project='project'
            @update='update'
          ></contacts>
        </v-col>
        <v-col cols='12' md='4'>
          <stickies
            v-if='project'
            :project='project'
          ></stickies>
        </v-col>

      </v-row>
      <v-row>
        <v-col cols='12' md='4'>
          <office-instructions
            v-if='project'
            :project='project'
            @update='update'
          ></office-instructions>
        </v-col>
        <v-col cols='12' md='4'>
          <customer-notes
            v-if='project'
            :project='project'
            @update='update'
          ></customer-notes>
        </v-col>
        <v-col cols='12' md='4'>
          <invoicing-notes
            v-if='project'
            :project='project'
            @update='update'
          ></invoicing-notes>
        </v-col>
      </v-row>
      <wc-page-section class='mt-n7' title='Files'></wc-page-section>
        <v-row style="padding-bottom: 150px;">
          <v-col cols='12' md='12'>
            <project-files
              v-if="project"
              :files='project.project_file_data'
              :project_id='project.id'
            ></project-files>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '@/modules/projects/components/Basics';
import Contacts from '@/modules/projects/components/Contacts';
import ProjectFiles from '@/components/files/ProjectFiles';
import OfficeInstructions from '@/modules/projects/components/OfficeInstructions';
import CustomerNotes from '@/modules/projects/components/CustomerNotes';
import InvoicingNotes from '@/modules/projects/components/InvoicingNotes';
import Stickies from '@/modules/projects/components/Stickies';
import ConstructionDetails from '@/modules/construction/components/ConstructionDetails';

export default {
  name: 'construction-overview',
  props: {
    project: {
      required: true
    }
  },
  methods: {
    update (project) {
      this.$emit('update', project)
    }
  },
  components: {
    'basics': Basics,
    'contacts': Contacts,
    'office-instructions': OfficeInstructions,
    'project-files': ProjectFiles,
    'customer-notes': CustomerNotes,
    'invoicing-notes': InvoicingNotes,
    'stickies': Stickies,
    'construction-details': ConstructionDetails
  }
}
</script>